import utils from "../../../src/js/utils";
var circleImg = {
	els: document.querySelectorAll(".circle-animation"),
	animation: function () {
		utils.forEach(circleImg.els, function (index, el) {
			var inner = el.querySelector(".inner");
			gsap
				.timeline({
					scrollTrigger: {
						trigger: el,
						start: "top bottom",
						end: "bottom bottom",
						scrub: 1.8,
					},
				})
				.to(inner, {
					//TODO vedere se basta 75 su mobile altrimenti mettere dinamico
					clipPath: "ellipse(80vmax 80vmax at 50% 50%)",
					duration: 2,
				})
				.to(inner.querySelector("img"), { scale: 1, duration: 2 }, "<");
		});
	},
	init: function () {
		if (circleImg.els.length > 0) {
			circleImg.animation();
		}
	},
};

utils.domReady(function () {
	circleImg.init();
});
